export default {
	// header Menu
	user_menu_kccIntro: 'KCC 소개',
	user_menu_product: 'Product',
	user_menu_market: 'Market',
	user_menu_productSupport: '제품지원',
	user_menu_customerSupport: '고객지원',

	user_marketMain: 'Market 메인',
	user_functionMain: 'Function 메인',

	// KCC소개
	user_common_kccIntro : 'KCC 소개',
	user_common_kccIntro_kccam : 'KCC Advanced Materials',
	user_common_kccIntro_globalNetwork : 'Global Network',
	user_common_kccIntro_newsRoom : 'Newsroom',
	user_common_next : '다음',
	user_common_complete : '완료',

	user_common_View : 'View',
	user_common_By: 'By',
	user_common_store: 'Store',
	user_common_RelatedApplication: '관련 Application',

	// product 정보
	user_common_product : 'Product',
	user_common_product_application_etc : '기타',
	user_common_product_mouseover_txt : '더 알아보기',

	user_product_guide_tit : 'KTMC series selection guide(LSI devices)',
	user_product_guide_Package : '패키지',
	user_product_guide_Product : '제품',
	user_product_guide_Features : 'Features',
	user_product_guide_Type : '타입',
	user_product_guide_Devices : 'Devices',
	user_product_guide_LSI : 'LSI',

	user_product_LeadFrame : 'Lead Frame',
	user_product_Substract : 'Substrate',
	user_product_Description : '설명',
	user_product_introduction_tit : 'KCC EMC 소개(Power Module FP)',
	user_product_introduction : '소개',

	user_product_TestItem : 'TEST ITEM',
	user_product_Unit : 'Unit',
	user_product_Typical : 'Typical',
	user_product_TestMethod : '시험 방법',
	user_product_Value : '값',

	//datasheet modal
	user_datasheetModal_showList : '전체 리스트 보기',
	user_datasheetModal_swalWithOptions_tit : '수정사항 체크',
	user_datasheetModal_swalWithOptions_contents : '두 개 이상의 행을 체크해주세요',

	// Technical DataSheet
	user_common_product_technicalDataSheet : 'Technical DataSheet',

	// product dataSheet 제목
	user_common_product_productDataSheet : 'Product Datasheet',

	// datasheet 하단 버튼
	user_common_product_dataSheet_compareBtn : '제품 비교하기',

	// Similar Product
	user_common_product_similarProduct : 'Similary Product',
	user_common_product_similarProduct_no : 'No.',
	user_common_product_similarProduct_series : 'Series',
	user_common_product_similarProduct_name : '제품명',
	user_common_product_similarProduct_summary : '요약',

	user_common_product_ViewSummary : '요약 자료 보기',

	// classification 관련 내용
	user_common_productClassification : 'Product Classification',
	user_common_application : 'Application',
	user_common_detail_application : 'Application Detail',

	// markets
	user_common_market : 'Market',

	// function
	user_common_function : 'Function',

	// page footer
	user_common_footer_address : '서울특별시 서초구 사평대로 344 | 고객상담실 080 - 022 - 8200, 대표번호 02 - 3480 - 5000',
	user_common_footer_copyright : 'COPYRIGHT (C) 2017 KCC CORPORATION ALL RIGHTS RESERVED',

	user_common_footer_lang : '언어',
	user_common_footer_repreNumber : '대표번호',
	user_common_footer_familySite : '패밀리사이트',
	user_common_footer_familySite_subTxt1 : 'KCC의 패밀리 사이트를 소개합니다.',
	user_common_footer_familySite_subTxt2 : '아래 계열사를 선택하시면 해당 홈페이지로 이동합니다.',
	user_common_footer_familySite_kccCorporation : 'KCC 홈페이지',
	user_common_footer_familySite_facebook : 'KCC 공식 페이스북',
	user_common_footer_familySite_blog : 'KCC 공식 블로그',
	user_common_footer_familySite_automobileMt : 'KCC 자동차보수용도료',
	user_common_footer_familySite_shipPaint : 'KCC 선박도료',
	user_common_footer_familySite_basketballTeam : 'KCC 이지스 프로농구단',
	user_common_footer_familySite_colorDesign : 'KCC 컬러&디자인센터',
	user_common_footer_familySite_glass : 'KCC 글라스',
	user_common_footer_familySite_homecc : '홈씨씨',
	user_common_footer_familySite_construction : 'KCC 건설',
	user_common_footer_familySite_kccsilicone : 'KCC 실리콘',
	user_common_footer_familySite_genmgang : '금강레저',
	user_common_footer_familySite_basildon : '바실돈',
	user_common_footer_policyPrivacy : '개인정보처리방침',

	// Main페이지
	// popup
	user_main_popup_header : '신제품 출시',
	user_main_popup_footer : '일주일동안 팝업을 띄우지 않습니다.',
	user_main_popup_close : '닫기',

	user_main_youtube_tit : 'The ADVANCED MATERIALS OF KCC',
	user_main_youtube_play : 'play',

	// 헤더
	user_main_slider_header1_tit : 'EMC Organic Material',
	user_main_slider_header1_subtxt : 'Electromagnetic Compatibility',

	user_main_slider_header2_tit : 'EMI Radiation',
	user_main_slider_header2_subtxt : 'Electromagnetic Interference',

	user_main_slider_header3_tit : 'EMS Sensivity',
	user_main_slider_header3_subtxt : 'Electromagnetic Susceptibility',

	user_main_globalNetwork : '글로벌 네트워크 상세보기',

	// KCC 소개 페이지
	// 헤더
	user_intro_introKcc_header_tit : 'KCC 소개',
	user_intro_introAM_header_tit : 'KCC AM',
	user_intro_introKcc_header_subtxt : 'KCC 소개 상세 내용입니다.',
	user_intro_introAM_header_subtxt : 'KCC AM 소개입니다.',
	user_intro_introAM_body_tit : '미래산업의 좌표, KCC 첨단소재에서 찾다',
	user_intro_introAM_body_subtxt1 : 'KCC의 첨단소재는 <strong>유기소재, 무기소재, 복합소재</strong><br/>로 구분되며, 각 소재별로 다양한 산업에 공급되고 있습니다.',

	user_intro_introAM_body_content1_tit : '유기소재',
	user_intro_introAM_body_content1_subtxt : 'KCC 유기소재는 반도체용 봉지재(EMC)와 전기전자용 접착제가 있습니다.\n'
		                                     +'KCC유기소재는 휴대폰, 냉장고, TV 등 일반 가전제품과 산업용 장비, 자동차까지 반도체가 쓰이는 대부분의 제품에 사용됩니다.\n'
											 +'IT 첨단 기술력이 반영된 제품이 증가함에 따라 전 세계 반도체 시장이 확대되고 있으며, KCC 유기소재의 수요도 증가하는 추세입니다.\n\n'
		                                     +'반도체용 소재로는 각종 접착제(DAP, Underfill)등이 있습니다.\nKCC 반도체용 소재는 세계적인 반도체 메이커의 공정에 최적화되어 타사 대비 월등한 성능을 보여주고 있습니다.\n'
		                                     +'디스플레이용 소재로는 UV몰딩재, UV실링재 등이 있으며, 더욱 높은 품질과 앞선 기술력으로 국내외 유수의 고객에게 판매 및 판촉 중에 있습니다.',
	user_intro_introAM_body_content2_tit : '무기소재',
	user_intro_introAM_body_content2_subtxt : 'KCC 무기소재는 '+ '<strong>Metalized Ceramic</strong>과 <strong>Ceramic Substrate</strong>로 구분할 수 있습니다.\n\n'
											+'무기재료 분야에서 축적된 기술과 경험으로 첨단 무기 신소재인 Fine Ceramics를 개발 공급하고 있습니다.\n'
											+'KCC 는 최신 장비 및 첨단 기술 도입으로 효율적인 자동화 공정을 구축하고,\n'
											+'엄격한 통합 품질 관리 시스템을 적용하여 KCC Metalized Ceramics를 생산합니다. \n특히 KCC의 VI(Vacuum Interrupter)용 세라믹 튜브(Ceramic Tube)는 세계 1위의 점유율을 자랑하며\n'
											+'KOTRA가 선정한 2020년 세계일류상품에 12년 연속 선정되기도 했습니다.\n\n'
											+'세라믹 기판 성형 (Tape Casting) 기술을 기반으로 파워모듈의 핵심소재인 세라믹기판 제품을 생산하고 있으며,\n알루미나(AI2O3)와 질화알루미늄(AIN)을 원료로 한 DCB 기판 등 다양한 세라믹 기판 기술을 보유하고 있습니다.\n'
											+'최근 전기자동차 수요 증가에 따라 자동차 전장용으로 전기를 미세하게 컨트롤하는 제어부에 HIC 기판 적용이 검토되고 있습니다.\n'
											+'전기출력을 내고 교류, 작류를 변환해야하는 파워부에는 고신뢰성 기판인 Si3N4 AMB, ZTA DCB 등이 적용됩니다.',

	user_intro_introAM_body_content3_tit : '복합소재',
	user_intro_introAM_body_content3_subtxt : 'KCC 복합소재인 유리 장섬유는 납석, 석회석 등의 무기 원료를 혼합해 1,500℃ 이상의 고온에서 녹인 후,' +
											'<br />작은 구멍을 통해 마이크로미터(백만 분의 1미터) 단위의 얇은 실 형태로 뽑아낸 제품입니다. <br />일반 플라스틱은 깨지기가 쉽고 열에 약하며, 치수안정성이 떨어지는' +
											'단점이 있습니다. <br />하지만 여기에 유리 장섬유를 적용하면 물리적 강도가 높은 강화 플라스틱으로 재탄생합니다. <br />유리장섬유가 절연성은 물론 치수안정성과 강도' +
											'등의 물성을 보완해주기 때문입니다.<br />' +
											'<br />KCC가 생산하는 유리 장섬유로는 촙 스트랜드(Chopped Strand), 촙 스트랜드 매트 Chopped Strand Mat), <br />다이렉트 로빙(DirectRoving), 컨벤셔널' +
											'로빙(Conventional Roving), 우븐 로빙(Woven Roving) 티슈(Tissue) 등이 있습니다. <br />KCC 유리 장섬유는 LCD TV 및 모니터의 백 패널(Back Panel)뿐만 아니라 전기·전자,' +
											'자동차, 토목 건축 등 산업 전반에서 광범위하게 사용됩니다.',



	// body
	user_intro_introKcc_introSection_addr : '서울특별시 서초구 사평대로 344',
	user_intro_introKcc_introSection_roundSpan_addr : '본사주소',
	user_intro_introKcc_introSection_roundSpan_establish : '설립일',
	user_intro_introKcc_introSection_roundSpan_establish_contxt : '1958년 8월 12일',
	user_intro_introKcc_introSection_roundSpan_employees : '임직원 수',
	user_intro_introKcc_introSection_roundSpan_employees_number : '명',
	user_intro_introKcc_introSection_roundSpan_criteriaAsDate1 : '2020년 9월 30일 기준',
	user_intro_introKcc_introSection_roundSpan_sales : '매출액',
	user_intro_introKcc_introSection_roundSpan_criteriaAsDate2 : '2023년 별도 기준',
	user_intro_introKcc_introSection_roundSpan_unit : '단위 : 백만원',

	user_intro_introKcc_detail_tit : 'KCC 사업내용',
	user_intro_introKcc_detail_header1_tit : '건축내장재',
	user_intro_introKcc_detail_header1_contxt1 : '천장재, 보온단열재, 석고보드',
	user_intro_introKcc_detail_header2_tit : '창호재',
	user_intro_introKcc_detail_header2_contxt1 : '일반창호, 발코니 창호, 시스템 창호',
	user_intro_introKcc_detail_header3_tit : '도료',
	user_intro_introKcc_detail_header3_contxt1 : '건축용 도료, 자동차용 도료, 선박용 도료',
	user_intro_introKcc_detail_header3_contxt2 : '플랜트용 도료, 공업용 도료',
	user_intro_introKcc_detail_header4_tit : '첨단소재',
	user_intro_introKcc_detail_header4_contxt1 : '유기소재(EMC), 무기소재(AM, DCB)',
	user_intro_introKcc_detail_header4_contxt2 : '복합소재',

	// NewsRoom
	user_intro_newsroom_header_tit : 'Newsroom',
	user_intro_newsroom_header_subtxt : 'Newsroom 상세 내용입니다',
	user_intro_newsroom_search_placeholder : '제목을 검색하세요',

	// newroom_view
	user_intro_newsroom_view_relatedProduct : '관련제품',
	user_intro_newsroom_view_regDate : '작성일',
	user_intro_newsroom_view_hits : '조회수',
	user_intro_newsroom_view_list : '목록',

	// theGlobalNetwork
	user_intro_globalNetwork_header_tit: 'Global Network',
	user_intro_globalNetwork_header_subtxt: 'Global Network 상세내용입니다.',

	user_common_nowLoading : '데이터 로딩 중입니다.',
	user_common_noData : '데이터가 없습니다.',
	user_common_korea : '대한민국',
	user_common_japan : '일본',
	user_common_china : '중국',
	user_common_veitnam : '베트남',
	user_common_malaysia : '말레이시아',
	user_common_singapore : '싱가포르',
	user_common_indonesia : '인도네시아',
	user_common_india : '인도',
	user_common_uae : 'UAE',
	user_common_turkey : '터키',
	user_common_germany : '독일',
	user_common_uk : '영국',

	// customerSupport_inquery 1:1 문의
	// 상단 배너
	user_customerSupportInquiry_noticeBanner_tit : '1대1 문의 이용안내',
	user_customerSupportInquiry_noticeBanner_txt1 : '해당 게시판 성격에 맞지 않는 내용, 욕설, 광고 등은 사전고지 없이 관리자에 의해 삭제될 수 있습니다.',
	user_customerSupportInquiry_noticeBanner_txt2 : '1:1 문의에 대한 답변은 이메일로만 발송되며 개인정보 관련 정책은',
	user_customerSupportInquiry_noticeBanner_txt3 : '개인정보처리방침',
	user_customerSupportInquiry_noticeBanner_txt4 : '을 확인바랍니다.',

	user_customerSupportInquiry_header_tit : '1:1문의',
	user_customerSupportInquiry_oneToOne_label : '문의종류',
	user_customerSupportInquiry_oneToOne_placeholder : '선택',
	user_customerSupportInquiry_essential_tit_header : '필수입력',
	user_customerSupportInquiry_essential_tit_subTxt : '1:1 문의를 위해 필수적으로 입력하는 항목입니다.',
	user_customerSupportInquiry_essential_email_label : '이메일',
	user_customerSupportInquiry_essential_email_placeholder1 : '이메일을 입력해주세요.',
	user_customerSupportInquiry_essential_email_placeholder2 : '이메일 서버를 입력해주세요.',
	user_customerSupportInquiry_essential_company_label : '회사명',
	user_customerSupportInquiry_essential_company_placeholder : '회사명을 입력해주세요.',

	user_customerSupportInquiry_elective_tit : '선택입력',
	user_customerSupportInquiry_elective_phone_label : '휴대폰번호',
	user_customerSupportInquiry_elective_name_label : '이름',
	user_customerSupportInquiry_elective_name_placeholder1 : '성을 입력해주세요.',
	user_customerSupportInquiry_elective_name_placeholder2 : '이름을 입력해주세요.',
	user_customerSupportInquiry_elective_department_label : '부서',
	user_customerSupportInquiry_elective_department_placeholder : '부서를 입력해주세요.',
	user_customerSupportInquiry_elective_tel_label : '전화번호',
	user_customerSupportInquiry_elective_country_label : '국가',
	user_customerSupportInquiry_elective_country_placeholder : '국가를 입력해주세요.',
	user_customerSupportInquiry_elective_city_label : '도시',
	user_customerSupportInquiry_elective_city_placeholder : '도시를 입력해주세요.',

	user_customerSupportInquiry_context_tit : '문의내용',
	user_customerSupportInquiry_context_label : '문의제목',
	user_customerSupportInquiry_context_placeholder1 : '문의제목을 입력해주세요.',
	user_customerSupportInquiry_context_placeholder2 : '문의내용을 입력하세요.',

	user_customerSupportInquiry_attach_tit : '첨부파일',
	user_customerSupportInquiry_attach_dropzone_tit : '업로드할 파일을 드래그하여 올려주세요.',
	user_customerSupportInquiry_attach_dropzone_subtit : '(또는 여기를 클릭하셔서 PC 에서 업로드할 파일을 선택하실 수도 있습니다.)',

	user_customerSupportInquiry_swal_inquiry : '1:1 문의',
	user_customerSupportInquiry_swal_inquiry_save : '1:1 문의 전송 결과',
	user_customerSupportInquiry_swal_save_success : '정상적으로 전송되었습니다.',
	user_customerSupportInquiry_swal_save_error : '전송 실패',
	user_customerSupportInquiry_swal_inquiry_needCategory : '1:1 문의 종류를 선택해주세요.',
	user_customerSupportInquiry_swal_inquiry_needlQuestion : '1:1 문의 세부 질문을 채워주세요.',
	user_customerSupportInquiry_swal_inquiry_needEssential : '필수입력 정보',
	user_customerSupportInquiry_swal_inquiry_needEmail : '이메일 입력란을 채워주세요',
	user_customerSupportInquiry_swal_inquiry_needCompany : '회사명을 채워주세요',
	user_customerSupportInquiry_swal_inquiry_needContext : '문의제목을 채워주세요.',
	user_customerSupportInquiry_swal_inquiry_needTitle : '',
	user_customerSupportInquiry_swal_inquiry_needValidEmail : '잘못된 이메일 주소입니다.',

	// customerSupport_contact
	//헤더
	user_customerSupportContact_header_tit : 'Contact',
	//body
	user_customerSupportContact_country_korea : '대한민국',
	user_customerSupportContact_country_china : '중국',
	user_customerSupportContact_country_japan : '일본',

	user_customerSupportContact_country_korea_branch_hq_tit : 'KCC 본사',
	user_customerSupportContact_country_korea_branch_hq_addr : '서울특별시 서초구 사평대로 344',
	user_customerSupportContact_country_china_branch_kunshan_tit : 'KCC (KUNSHAN)',
	user_customerSupportContact_country_china_branch_kunshan_addr : '11F, Shanghai HNA Building,No.898 Puming Road, Shanghai, China',

	user_customerSupportContact_country_china_branch_guangzhou_tit : 'KCC (GUANGZHOU)',
	user_customerSupportContact_country_china_branch_guangzhou_addr : 'Room 3703&3707, ZhongTai International square, NO.161 Linhe West Road, Guangzhou, China',
	user_customerSupportContact_country_japan_branch_yurakucho_tit : 'KCC Japan',
	user_customerSupportContact_country_japan_branch_yurakucho_addr : 'Yurakucho Denki Bldg. South wing 12F, 1-7-1, Yurakucho, Chiyoda-ku, Tokyo, Japan',

	user_customerSupportContact_manager_tit : 'Contact Manager',
	user_customerSupportContact_manager_tel : 'TEL',
	user_customerSupportContact_manager_email : 'EMAIL',

	//#### Market
	//## Market + Function 메인 페이지

	//### 헤더
	user_market_main_header_tit : 'Market',
	user_market_main_header_subtxt : 'KCC 첨단 소재는 반도체, 자동차, 전기전자/가전, 건축, 선박 등<br>다양한 산업에서 완벽한 성능을 구현하기 위해 적용되고 있습니다.',
	user_market_list_header_subtxt : 'Market 목록입니다.',
	user_market_view_header_subtxt : 'KCC 첨단 소재는 반도체, 자동차, 전기전자/가전, 건축, 선박 등<br> 다양한 산업에서 완벽한 성능을 구현하기 위해 적용되고 있습니다.<br>'
										+'KCC는 변화와 혁신을 통한 최고의 첨단소재를 통해 고객의 미래가치를 향상시키고 있습니다.',

	user_market_main_descr1 : 'KCC는 반도체, 자동차, 전기전자/가전, 건축, 선박 등 다양한 산업에 최첨단 소재를 공급하고 있습니다.',
	user_market_main_descr2 : 'KCC는 변화와 혁신을 통한 최고의 첨단소재를 통해 고객의 미래가치를 향상시키고 있습니다.',

	user_market_main_function_tit : 'Function',
	user_market_main_function_descr1 : 'KCC는 시장의 다양한 Needs를 반영한 최고 품질의 제품을 고객에게 공급하고 있습니다.',


	//### 본문
	user_market_main_button_market : 'Market 화면으로 이동',
	user_market_main_button_function : 'Function 화면으로 이동',

	//## Market 페이지
	//### market View
	//### Related Document
	user_market_relatedDocu_tit : '관련 문서',
	user_market_relatedDocu_docuName : '문서명',
	user_market_relatedDocu_docuType : '문서타입',
	user_market_relatedDocu_fileType : '파일형태',
	user_market_relatedDocu_download : '다운로드',
	user_market_relatedDocu_share : '공유',
	user_market_references : '참조',

	//market - function 관련
	user_market_function_subtit : 'Funtion 목록입니다.',
	user_market_function_detail_tit : 'KCC는 시장의 다양한 Needs를 반영한 최고 품질의 제품을 고객에게 공급하고 있습니다.',

	// 통합검색 (productsupport_integratedSearch)
	integratedSearch_tit : '통합검색',
	integratedSearch_quickLink : '빠른 링크',
	integratedSearch_inputSearch : '검색어를 입력하세요.',
	integratedSearch_searchResults : '검색결과 총',
	integratedSearch_founded : '건이 검색되었습니다.',
	integratedSearch_ProductName : 'Product',
	integratedSearch_Material : 'Material',
	integratedSearch_Function : 'Function',
	integratedSearch_MarketName : 'Market',
	integratedSearch_FunctionName : 'Function Name',

	integratedSearch_ApplicationName : 'Application',
	integratedSearch_ApplicationClassification : 'Application Classification',
	integratedSearch_DetailApplication : 'Detail Applcation',
	integratedSearch_Product : 'Product',

	// 기술지원
	integratedSearch_tecSupport_tit : '기술지원',
	integratedSearch_tecSupport_placeHolder : '문서 검색',

	integratedSearch_tecSupport_commonDoc : '회사공통문서',
	integratedSearch_tecSupport_introductionDoc : '제품소개자료',
	integratedSearch_tecSupport_TQDoc : '기술/품질자료',
	integratedSearch_tecSupport_crDoc : '인증서/성적서',
	integratedSearch_tecSupport_ptDoc : '제품교육자료',

	integratedSearch_tecSupport_fileName : '파일명',
	integratedSearch_tecSupport_fileType : '파일형태',
	integratedSearch_tecSupport_download : '다운로드',
	integratedSearch_tecSupport_share : '공유',

	//제품지원-제품 카탈로그
	productSupport_productCatalog_tit : '제품 카탈로그',
	productSupport_productCatalog_resultTxtAll : '전체 검색 결과 총',
	productSupport_productCatalog_resultTxt1 : '검색 결과 총',
	productSupport_productCatalog_resultTxt2 : '건이 검색되었습니다.',
	productSupport_productCatalog_publishedDate : '발행일',

	//confirmSwal
	user_common_confirmSwal_noSearchInput : '검색어를 입력해주세요.',
	user_common_confirmSwal_noSearchInput_desc : '',
	user_common_placeHolder_fileName : '파일명 검색',
	user_common_placeHolder_catalogName : '카탈로그명 검색',


	//contact
	user_contact_tit : 'Contact',
	user_contact_tel : 'TEL',
	user_contact_addr : 'ADDRESS',
	user_contact_email : 'EMAIL',
	user_contact_businessOffice : '영업소',
	user_contact_manager : '담당자',

	//share modal
	user_shareModal_tit: '기술지원 문서 공유',
	user_shareModal_inputLabel: 'e-mail',
	user_shareModal_placeHolder: 'e-mail 입력',
	user_shareModal_btnConfirm: '확인',
	user_shareModal_btnCancel: '취소',
	user_shareModal_confirmSwal_content1: 'e-mail 주소를 입력해주세요',
	user_shareModal_confirmSwal_content2: 'e-mail 형식이 맞지 않습니다',

	//문서 다운
	user_docDownload_tit: '문서 다운로드',


	//글로벌 네트워크 주소==============

	user_globalNetwork_Headquarters_tit : '본사',
	user_globalNetwork_Headquarters_seoul : '서울본사',
	user_globalNetwork_Headquarters_address : '서울특별시 서초구 사평대로 344 (서초동 1301-4)',
	user_globalNetwork_Headquarters_call : '02-3480-5000',

	user_globalNetwork_CentralResearch_tit : '중앙연구소',
	user_globalNetwork_CentralResearch_subtit : '중앙연구소',
	user_globalNetwork_CentralResearch_address : '경기도 용인시 기흥구 마북로 240번길 17-3(마북동 83)',
	user_globalNetwork_CentralResearch_call : '031-288-3000',

	user_globalNetwork_Factory_tit : '공장',

	user_globalNetwork_Factory_Gapyeong : '가평공장',
	user_globalNetwork_Factory_Gapyeong_production : '유리용 규사',
	user_globalNetwork_Factory_Gapyeong_address : '경기도 가평군 가평읍 물안산길 42 (개곡리 산 280)',
	user_globalNetwork_Factory_Gapyeong_call : '031-580-1500',

	user_globalNetwork_Factory_Gimcheon : '김천공장',
	user_globalNetwork_Factory_Gimcheon_production : '그라스울',
	user_globalNetwork_Factory_Gimcheon_address : '경상북도 김천시 어오면 산업단지로 39(남산리 1936번지)',
	user_globalNetwork_Factory_Gimcheon_call : '054-420-1700',

	user_globalNetwork_Factory_DaejukGypsumBoard : '대죽석고보드공장',
	user_globalNetwork_Factory_DaejukGypsumBoard_production : '석고보드',
	user_globalNetwork_Factory_DaejukGypsumBoard_address : '충청남도 서산시 대산읍 대죽2로 15(대죽리 11-1)',
	user_globalNetwork_Factory_DaejukGypsumBoard_call : '041-660-7000',

	user_globalNetwork_Factory_DaejukSilicone : '대죽실리콘공장',
	user_globalNetwork_Factory_DaejukSilicone_production : '실리콘',
	user_globalNetwork_Factory_DaejukSilicone_address : '충청남도 서산시 대산읍 대죽2로 35(대죽리 11-4)',
	user_globalNetwork_Factory_DaejukSilicone_call : '041-660-8700',

	user_globalNetwork_Factory_Munmak : '문막공장',
	user_globalNetwork_Factory_Munmak_production : '그라스울',
	user_globalNetwork_Factory_Munmak_address : '강원도 원주시 문막읍 문막공단길 106(반계리 2239)',
	user_globalNetwork_Factory_Munmak_call : '033-749-4500',

	user_globalNetwork_Factory_Sejong : '세종공장',
	user_globalNetwork_Factory_Sejong_production : '유리장섬유',
	user_globalNetwork_Factory_Sejong_address : '세종특별자치시 전의면 소정구길 40(유천리 935)',
	user_globalNetwork_Factory_Sejong_call : '044-550-5600',

	user_globalNetwork_Factory_Anseong : '안성공장',
	user_globalNetwork_Factory_Anseong_production : '건축용도료 / 자동차보수용도료 / 공업용도료 / 플랜트용도료 / 플라스틱도료',
	user_globalNetwork_Factory_Anseong_address : '경기도 안성시 서운면 제4산단로 100 (동촌리 300)',
	user_globalNetwork_Factory_Anseong_call : '031-670-7777',

	user_globalNetwork_Factory_Asan : '아산공장',
	user_globalNetwork_Factory_Asan_production : '바닥재 / 라미필름',
	user_globalNetwork_Factory_Asan_address : '충청남도 아산시 염치읍 아산로 658-33(서원리 71)',
	user_globalNetwork_Factory_Asan_call : '041-539-9000',

	user_globalNetwork_Factory_Yeocheon : '여천공장',
	user_globalNetwork_Factory_Yeocheon_production : '석고보드',
	user_globalNetwork_Factory_Yeocheon_address : '전라남도 여수시 상암로 830-7(낙포동 880)',
	user_globalNetwork_Factory_Yeocheon_call : '061-680-7800',

	user_globalNetwork_Factory_Yeoju : '여주공장',
	user_globalNetwork_Factory_Yeoju_production : '유리',
	user_globalNetwork_Factory_Yeoju_address : '경기도 여주시 가남읍 여주남로 541(본두리 1-2)',
	user_globalNetwork_Factory_Yeoju_call : '031-880-3000',

	user_globalNetwork_Factory_Yeongwol : '영월공장',
	user_globalNetwork_Factory_Yeongwol_production : '유리용 백운석 / 카스마이트 생산',
	user_globalNetwork_Factory_Yeongwol_address : '강원도 영월군 북면 원동재로 282- 54 (문곡리 783-1)',
	user_globalNetwork_Factory_Yeongwol_call : '033-370-1500',

	user_globalNetwork_Factory_Ulsan : '울산공장',
	user_globalNetwork_Factory_Ulsan_production : '선박도료 / 플랜트도료 / 자동차용도료 / 공업용도료',
	user_globalNetwork_Factory_Ulsan_address : '울산광역시 동구 방어진순환도로 30(방어동 1234)',
	user_globalNetwork_Factory_Ulsan_call : '052-280-1717',

	user_globalNetwork_Factory_JeonjuBuilding : '전주건재공장',
	user_globalNetwork_Factory_JeonjuBuilding_production : '창호 / 금속접합세라믹',
	user_globalNetwork_Factory_JeonjuBuilding_address : '전라북도 완주군 봉동읍 완주산단4로 19(용암리 820)',
	user_globalNetwork_Factory_JeonjuBuilding_call : '063-260-8800',

	user_globalNetwork_Factory_JeonjuPainting : '전주도료공장',
	user_globalNetwork_Factory_JeonjuPainting_production : '건축용도료 / 수지 / EMC / 분체도료',
	user_globalNetwork_Factory_JeonjuPainting_address : '전라북도 완주군 봉동읍 과학로 764(용암리 846)',
	user_globalNetwork_Factory_JeonjuPainting_call : '063-260-7000',

	user_globalNetwork_Factory_JeonjuSilicone : '전주실리콘공장',
	user_globalNetwork_Factory_JeonjuSilicone_production : '실리콘',
	user_globalNetwork_Factory_JeonjuSilicone_address : '전라북도 완주군 봉동읍 과학로 801(용암리 844)',
	user_globalNetwork_Factory_JeonjuSilicone_call : '063-260-1700',

	//영업소
	user_globalNetwork_businessOffice_tit : '영업소',

	user_globalNetwork_businessOffice_Seongnam : '성남 영업소',
	user_globalNetwork_businessOffice_Seongnam_address : '경기도 성남시 분당구 대왕판교로 210 (금곡동 92-7)',
	user_globalNetwork_businessOffice_Seongnam_call : '031-728-6800',

	user_globalNetwork_businessOffice_GyeonggiNorth : '경기북부 영업소',
	user_globalNetwork_businessOffice_GyeonggiNorth_address : '경기도 고양시 덕양구 고양대로 2014 (동산동 50-28)',
	user_globalNetwork_businessOffice_GyeonggiNorth_call : '031-841-0208',

	user_globalNetwork_businessOffice_Namyangju : '남양주 출장소',
	user_globalNetwork_businessOffice_Namyangju_address : '경기도 남양주시 다산중앙로172번길 44, 201호(다산동 5779-1)',
	user_globalNetwork_businessOffice_Namyangju_call : '031-554-4326',

	user_globalNetwork_businessOffice_Suwon : '수원 영업소',
	user_globalNetwork_businessOffice_Suwon_address : '경기도 수원시 팔달구 경수대로 472 (인계동 1018)',
	user_globalNetwork_businessOffice_Suwon_call : '031-235-5001',

	user_globalNetwork_businessOffice_Ansan : '안산 출장소',
	user_globalNetwork_businessOffice_Ansan_address : '경기도 안산시 단원구 선부광장1로 92 메이퀸오피스텔 206호',
	user_globalNetwork_businessOffice_Ansan_subAddress : '(선부동 1076-21)',
	user_globalNetwork_businessOffice_Ansan_call : '031-487-7534',

	user_globalNetwork_businessOffice_Hwaseong : '화성 출장소',
	user_globalNetwork_businessOffice_Hwaseong_address : '경기도 화성시 향남읍 발안만세길 14 (제암리 186)',
	user_globalNetwork_businessOffice_Hwaseong_call : '031-487-7534',

	user_globalNetwork_businessOffice_Wonju : '원주 영업소',
	user_globalNetwork_businessOffice_Wonju_address : '강원도 원주시 북원로 2461(우산동 96-2)',
	user_globalNetwork_businessOffice_Wonju_call : '033-744-6821',

	user_globalNetwork_businessOffice_Gangneung : '강릉 출장소',
	user_globalNetwork_businessOffice_Gangneung_address : '강원도 강릉시 연곡면 연주로 135(방내리 9)',
	user_globalNetwork_businessOffice_Gangneung_call : '033-662-1705',

	user_globalNetwork_businessOffice_Daejeon : '대전 영업소',
	user_globalNetwork_businessOffice_Daejeon_address : '대전광역시 대덕구 신탄진로 150(연축동 230)',
	user_globalNetwork_businessOffice_Daejeon_call : '042-635-4323',

	user_globalNetwork_businessOffice_Cheongju : '청주 영업소',
	user_globalNetwork_businessOffice_Cheongju_address : '충청북도 청주시 흥덕구 2순환로 1130 스타로미안 7층(비하동 236-10)',
	user_globalNetwork_businessOffice_Cheongju_call : '043-262-4200',

	user_globalNetwork_businessOffice_Cheonan : '천안 영업소',
	user_globalNetwork_businessOffice_Cheonan_address : '세종특별자치시 전의면 소정구길 40(유천리 935)',
	user_globalNetwork_businessOffice_Cheonan_call : '044-550-5601',

	user_globalNetwork_businessOffice_Dangjin : '당진 영업소',
	user_globalNetwork_businessOffice_Dangjin_address : '충청남도 당진시 신평면 서해로 6719(거산리 694-3)',
	user_globalNetwork_businessOffice_Dangjin_call : '041-363-4266',

	user_globalNetwork_businessOffice_Jeonju : '전주 영업소',
	user_globalNetwork_businessOffice_Jeonju_address : '전라북도 전주시 덕진구 동곡로 84(팔복동 2가 339-1)',
	user_globalNetwork_businessOffice_Jeonju_call : '063-211-5300',

	user_globalNetwork_businessOffice_Gwangju : '광주 영업소',
	user_globalNetwork_businessOffice_Gwangju_address : '광주광역시 광산구 무진대로 270(우산동 1596-2)',
	user_globalNetwork_businessOffice_Gwangju_call : '062-943-8211',

	user_globalNetwork_businessOffice_Mokpo : '목포 출장소',
	user_globalNetwork_businessOffice_Mokpo_address : '전라남도 무안군 삼향읍 후광대로 274 남악도청프라자 301호 KCC목포지점',
	user_globalNetwork_businessOffice_Mokpo_subAddress : '(남악리 2112)',
	user_globalNetwork_businessOffice_Mokpo_call : '061-280-5935',

	user_globalNetwork_businessOffice_Suncheon : '순천 영업소',
	user_globalNetwork_businessOffice_Suncheon_address : '전라남도 순천시 장선배기길 3(조례동 1595-3)',
	user_globalNetwork_businessOffice_Suncheon_call : '061-722-7722',

	user_globalNetwork_businessOffice_Daegu : '대구 영업소',
	user_globalNetwork_businessOffice_Daegu_address : '대구광역시 중구 태평로 111 (태평로3가 214-25)',
	user_globalNetwork_businessOffice_Daegu_call : '053-252-0227',

	user_globalNetwork_businessOffice_Gumi : '구미 출장소',
	user_globalNetwork_businessOffice_Gumi_address : '경상북도 구미시 산동면 첨단기업7로 103(신당리 1367)',
	user_globalNetwork_businessOffice_Gumi_call : '054-453-4530',

	user_globalNetwork_businessOffice_Pohang : '포항 영업소',
	user_globalNetwork_businessOffice_Pohang_address : '경상북도 포항시 남구 희망대로 695 (상도동 669-6)',
	user_globalNetwork_businessOffice_Pohang_call : '054-275-7601',

	user_globalNetwork_businessOffice_Ulsan : '울산 영업소',
	user_globalNetwork_businessOffice_Ulsan_address : '울산광역시 북구 진장유통로 28-17(진장동 285-1)',
	user_globalNetwork_businessOffice_Ulsan_call : '052-287-0811',

	user_globalNetwork_businessOffice_Busan : '부산 영업소',
	user_globalNetwork_businessOffice_Busan_address : '부산광역시 금정구 중앙대로 1628(부곡동 269-1)',
	user_globalNetwork_businessOffice_Busan_call : '051-580-5200',

	user_globalNetwork_businessOffice_Changwon : '창원 영업소',
	user_globalNetwork_businessOffice_Changwon_address : '경상남도 창원시 의창구 무역로 563(팔용동 8-36)',
	user_globalNetwork_businessOffice_Changwon_call : '055-265-3211',

	user_globalNetwork_businessOffice_Jeju : '제주 영업소',
	user_globalNetwork_businessOffice_Jeju_address : '제주특별자치도 제주시 연삼로 340(도남동 65-10)',
	user_globalNetwork_businessOffice_Jeju_call : '064-726-8870',

	//user_main 비주얼 스와이퍼
	user_main_visual01_tit : 'KCC, Your Solution Partner',
	user_main_visual01_descr : '미래를 위한 최첨단 솔루션을 제공합니다.',
	user_main_visual02_tit : '첨단 소재로 내일을 앞당기는 기술',
	user_main_visual02_descr : '반도체와 전기전자 핵심재인 봉지재 절연재',
	user_main_visual03_tit : '미래를 만들어 가는 기술이 있습니다.',
	user_main_visual03_descr : '엔지니어링 플라스틱 원료, 유리장섬유',

	//product_main 비주얼 스와이퍼
	product_main_visual_EMC_tit : 'EMC',
	product_main_visual_EMC_descr : '다양한 반도체에 적용 가능하며, 안정적인 반도체 성능을 위해 우수한 작업성, 성형성 및 신뢰성을 갖췄습니다.',
	product_main_visual_Adhesive_tit : 'Adhesive',
	product_main_visual_Adhesive_descr : '반도체용 접착소재로 우수한 작업성과 신뢰성을 바탕으로 고성능 반도체에 적용 가능합니다.',
	product_main_visual_MetalizedCeramics_tit : 'Metalized Ceramic',
	product_main_visual_MetalizedCeramics_descr : 'KCC 세라믹 튜브를 적용한 VI(Vacuum Interrupter)용 세라믹은 접합 성능, 조직 치밀성, 진공 기밀성이 우수하며</br>송배전용과 수배전용 진공차단기에 적용되며 12년 연속 세계 일류상품에 선정되었습니다.</br>그 외 다양한 Power Tube, 금속접합 세라믹 제품도 양산, 공급 중입니다',
	product_main_visual_CeramicSubstrates_tit : 'Ceramic Substrate',
	product_main_visual_CeramicSubstrates_descr : '세라믹 기판에 DCB, AMB 공법으로 구리를 접합하여 파워모듈 반도체의 기판으로 사용됩니다.</br>다양한 세라믹에 구리를 접합하며, 고객 니즈에 맞는 강도와 방열 성능을 갖추고 있어</br>자동차용, 산업용, 가전용 파워모듈 반도체 기판으로 적용되고 있습니다.',
	product_main_visual_GlassFiber_tit : 'Glass fiber',
	product_main_visual_GlassFiber_descr : '엔지니어링 플라스틱 물성을 보강하기 위해 사용하는 유리 섬유입니다.</br>전기전자 및 가전, 자동차, 건축, 선박 등 다양한 산업의 적용됩니다.</br>경량화, 치수안정성, 저연성, 냉화학성 등 각 산업별 니즈에 대응 가능한 물성을 제공합니다.',

	//데이터 시트, 엑셀 다운로드
	datasheet_download : '엑셀 다운로드',
	datasheet_fullScreen : '전체 화면',
	datasheet_compareProducts : '제품 비교하기',
	datasheet_fullList : '전체 리스트 보기',

	// design rule 다운로드
	design_rule_download : 'Design Rule 다운로드',

	//중국 도시
	globalNetwork_china_Shanghai : '상하이',
	globalNetwork_china_Beijing : '베이징',
	globalNetwork_china_Guangzhou : '광저우',
	globalNetwork_china_Chongqing : '충칭',

	//외부파일
	filetype_externalFile : '외부파일',

	// 팝업
	hideToday: '오늘 하루 열지 않기',
	close: '닫기',

}

